module.exports = __webpack_public_path__ + "70df8b86e49fe62df96819a7a8b39798.png";